import { formatDateIN } from '../../utils/dateFormat';
import { openPrintWindow } from '../../utils/exportUtils';

export const formatCellValue = (value, type) => {
  if (value == null || value === '') return '-';
  if (type === 'boolean') return value === true || value === 'true' || value === 'Yes' ? 'Yes' : 'No';
  if (type === 'currency') {
    return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Number(value) || 0)}`;
  }
  if (type === 'date') return formatDateIN(value);
  if (type === 'number') return new Intl.NumberFormat('en-IN').format(Number(value) || 0);
  return String(value);
};

export const rowsToCsv = (columns, rows) => {
  const header = columns.map((c) => `"${String(c.label).replace(/"/g, '""')}"`).join(',');
  const body = rows.map((row) => columns.map((c) => {
    const raw = formatCellValue(row[c.key], c.type);
    return `"${String(raw).replace(/"/g, '""')}"`;
  }).join(','));
  return [header, ...body].join('\n');
};

export const downloadCustomReportCsv = (columns, rows, filename = 'custom-report.csv') => {
  const csv = rowsToCsv(columns, rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const printCustomReport = ({ title, subtitle, columns, rows, totals }) => {
  const head = columns.map((c) => `<th>${c.label}</th>`).join('');
  const body = rows.map((row) => `<tr>${columns.map((c) => `<td>${formatCellValue(row[c.key], c.type)}</td>`).join('')}</tr>`).join('');
  const foot = totals && Object.keys(totals).length
    ? `<tr>${columns.map((c) => `<td><strong>${totals[c.key] != null ? formatCellValue(totals[c.key], c.type) : ''}</strong></td>`).join('')}</tr>`
    : '';
  openPrintWindow({
    title: title || 'Custom Report',
    subtitle: subtitle || '',
    bodyHtml: `<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody>${foot ? `<tfoot>${foot}</tfoot>` : ''}</table>`,
  });
};
